import { useDevice } from '.';
interface CoreHookReturn {
  gotoPtEApp: () => void;
}
export const useCore = (): CoreHookReturn => {
  const isApp = useDevice().isApp;
  const gotoPtEApp = () => {
    //   console.trace();
    if (isApp) {
      window.location.href = `../index.html`;
    } else {
      window.location.href = `${import.meta.env.VITE_PTE_URL}/sso/subscription?d=${new Date().getTime()}`;
    }
  };

  return {
    gotoPtEApp,
  };
};
